export default "__VITE_ASSET__DaT4QwqW__"